const transitions = {
  duration: {
    enteringScreen: 325,
    leavingScreen: 295
  }
};
export default transitions;